import { CommonModule } from '@angular/common';
// Angular imports
import { NgModule } from '@angular/core';

// Design System imports
import { SharedModule } from '../../shared/shared.module';
import { HomeComponent } from './home.component';

import { TimelineModule } from '@michelin/theme';

// BTN imports
import { AssetManagementModule } from '../../features/asset-management/asset-management.module';
import { CustomerInfoModule } from '../../features/customer-info/customer-info.module';
import { UserManagementModule } from '../../features/user-management/user-management.module';
import { WorkorderModule } from '../../features/workorder/workorder.module';

@NgModule({
  imports: [CommonModule, SharedModule, CustomerInfoModule, AssetManagementModule, UserManagementModule, WorkorderModule, TimelineModule],
  providers: [],
  declarations: [HomeComponent]
})
export class HomeModule {}
